import { defineMessages } from "react-intl";

const messages = defineMessages({
  connectedEmailDisconnect: {
    id: "settings.emailPreferences.connectedEmail.disconnect",
    defaultMessage: "Disconnect",
    description: "Settings Email Preferences connected email disconnect button",
  },
  connectedEmailDisconnectChangeEmail: {
    id: "settings.emailPreferences.connectedEmail.changeEmail",
    defaultMessage: "Change email",
    description: "Settings Email Preferences connected email change email button",
  },
  connectedEmailTitle: {
    id: "settings.emailPreferences.connectedEmail.title",
    defaultMessage: "Connected email",
    description: "Settings Email Preferences connected email title",
  },
  connectedInfo: {
    id: "settings.emailPreferences.connectedEmail.connectedInfo",
    defaultMessage: "Connected",
    description: "Settings Email Preferences connected email info",
  },
  emailQueueCount: {
    id: "settings.emailPreferences.emailQueue.count",
    defaultMessage: "{count} {count, plural, one {email} other {emails}} queued",
    description: "Settings Email Preferences email queue count",
  },
  emailQueueOpen: {
    id: "settings.emailPreferences.emailQueue.open",
    defaultMessage: "Open queue",
    description: "Settings Email Preferences email queue open button",
  },
  emailQueueTitle: {
    id: "settings.emailPreferences.emailQueue.title",
    defaultMessage: "Email Queue",
    description: "Settings Email Preferences email queue title",
  },
  limitSendingQueueDescription: {
    id: "settings.emailPreferences.limitSendingQueue.description",
    defaultMessage:
      "Only send queued emails between certain hours. Changes will take effect within 5 to 10 minutes.",
    description: "Settings Email Preferences limit sending queue description",
  },
  limitSendingQueueTitle: {
    id: "settings.emailPreferences.limitSendingQueue.title1",
    defaultMessage: "Sending Hours",
    description: "Settings Email Preferences limit sending queue title",
  },
  limitSendingQueueWeekends: {
    id: "settings.emailPreferences.limitSendingQueue.weekends",
    defaultMessage: "Exclude weekends",
    description: "Settings Email Preferences limit sending queue weekends",
  },
  openActivityDescription: {
    id: "settings.emailPreferences.openActivity.description",
    defaultMessage:
      "Activities are always created for you after sending emails. Turn this on to see the activity form after sending.",
    description: "Settings Email Preferences open activity description",
  },
  openActivityDisabledAlert: {
    id: "settings.emailPreferences.openActivity.alwaysOn.alert",
    defaultMessage:
      "Your activities form has at least one required field, or you have access to multiple layouts, so you will always see the activity form after sending an email in MMC.",
    description:
      "Settings Email Preferences open activity required fields or multiple layouts alert",
  },
  openActivityDisabledTooltip: {
    id: "settings.emailPreferences.openActivity.alwaysOn.tooltip",
    defaultMessage:
      "Your activities form has at least one required field, or you have access to multiple layouts, so this setting cannot be turned off.",
    description: "Settings Email Preferences open activity required fields or multiple layouts",
  },
  openActivityTitle: {
    id: "settings.emailPreferences.openActivity.title",
    defaultMessage: "Open the activity form after sending",
    description: "Settings Email Preferences open activity title",
  },
  showOpensAndClicksDescription: {
    id: "settings.emailPreferences.showOpensAndClicks.description",
    defaultMessage: "See if your email and links have been opened",
    description: "Settings Email Preferences show opens and clicks description",
  },
  showOpensAndClicksTitle: {
    id: "settings.emailPreferences.showOpensAndClicks.title",
    defaultMessage: "Show opens and clicks",
    description: "Settings Email Preferences show opens and clicks title",
  },
  signatureDescription: {
    id: "settings.emailPreferences.signature.description",
    defaultMessage: "Appended at the end of all outgoing messages",
    description: "Settings Email Preferences signature description",
  },
  signatureTitle: {
    id: "settings.emailPreferences.signature.title",
    defaultMessage: "Signature",
    description: "Settings Email Preferences signature title",
  },
  title: {
    id: "settings.emailPreferences.title",
    defaultMessage: "Email Preferences",
    description: "Title of settings Email Preferences page",
  },
  workingHoursEqualDatesError: {
    id: "settings.emailPreferences.workHours.equalDatesError",
    defaultMessage: "Start time and end time must be different",
    description: "Working hours equal dates error",
  },
});

export default messages;
